
























































































import { Component, Emit, Prop, Watch } from 'vue-property-decorator'

import { warningNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import { SelectOption } from '../../../../../../logic/types'
import {
  BotProperty,
  GroupedBotProperty,
  PropertyFieldType,
  PropertyGroup
} from '../../../../../BotProperties/components/Properties/types'
import { getPropertyTranslation } from '../../../../../BotProperties/utils'
import { PropertiesHelper, PropertyValueType, UserProfileConfig } from '../../../../../BotUserProfile/types'
import { UserProfileProperties } from '../../../../../BotUsers/components/Users/types'
import { UseFields } from '../../../../../Pi'
import SetUserPropertyField from '../../components/Properties/SetUserPropertyField.vue'
import PropertyValueValidator from './PropertyValueValidator'

@Component({
  data() {
    return {
      PropertyFieldType,
      PropertyValueValidator,
    }
  },
  components: {
    SetUserPropertyField,
  },
})
export default class SetUserProperty extends UseFields {
  @Prop() userId!: number

  @Prop() properties!: UserProfileProperties

  @Prop() existProperties!: Array<BotProperty['id']>

  @Prop() setProperty!: PropertiesHelper['setProperty']

  @Prop() getProperties!: PropertiesHelper['getProperties']

  @Prop() mediaTargetId!: UserProfileConfig['mediaTargetId']

  @Watch('isOpen')
  /**
   * При открытии модалки, сразу заполняем селект с выбором свойства первой свободной переменной
   */
  isOpenWatcher(val: boolean): void {
    if (val) {
      const freeProp = this.getProperties()
        .sort((a, b) => {
          if (a.group === b.group) {
            return 0
          } else if (a.group === PropertyGroup.System && b.group === PropertyGroup.Custom) {
            return -1
          } else {
            return 1
          }
        })
        .find((p) => !this.existProperties.includes(p.id))

      const strType = [
        PropertyFieldType.String,
        PropertyFieldType.Email,
        PropertyFieldType.Phone,
        PropertyFieldType.Date,
        PropertyFieldType.Time,
        PropertyFieldType.DateTime,
      ]

      if (freeProp) {
        if (strType.includes(freeProp.type)) {
          this.newPropValue = ''
        } else if (freeProp.type === PropertyFieldType.Number || freeProp.type === PropertyFieldType.Double) {
          this.newPropValue = 0
        } else {
          this.newPropValue = false
        }

        this.newPropId = freeProp.id
      }
    }
  }

  isOpen = false

  newPropId: null | BotProperty['id'] = null

  newPropValue: PropertyValueType | null = null

  get freeProperties() {
    return this.getProperties()
      .filter((prop) => !this.existProperties.includes(prop.id))
  }

  get customProps() {
    return this.freeProperties
      .filter((p) => p.group === PropertyGroup.Custom)
      .map((property) => {
        return {
          label: property.name,
          value: property.id
        }
      })
  }

  get systemProps() {
    return this.freeProperties
      .filter((p) => p.group === PropertyGroup.System && !p.automatic)
      .map(this.mapPropsToSelectOptions)
  }

  mapPropsToSelectOptions({ name, id, type }: Pick<GroupedBotProperty, 'name' | 'id' | 'type'>): SelectOption {
    return {
      label: getPropertyTranslation(this.$i18n, name ?? type),
      value: id
    }
  }

  get targetProperty() {
    return this.newPropId ? this.getProperties().find((p) => p.id === this.newPropId) : undefined
  }

  get propertyType(): PropertyFieldType | null {
    if (this.targetProperty) {
      if (this.targetProperty.type === PropertyFieldType.Number || this.targetProperty.type === PropertyFieldType.Double) {
        this.newPropValue = 0
      } else if (this.targetProperty.type === PropertyFieldType.Flag) {
        this.newPropValue = false
      } else if (this.targetProperty.type === PropertyFieldType.Files) {
        this.newPropValue = []
      } else {
        this.newPropValue = ''
      }

      return this.targetProperty.type
    }

    return null
  }

  get valueIsSet(): boolean {
    if (typeof this.newPropValue === 'string') {
      return this.newPropValue.length > 0
    } else if (typeof this.newPropValue === 'number') {
      return !isNaN(this.newPropValue)
    } else {
      return true
    }
  }

  setPropertyHandler(): void {
    if (this.userId && this.newPropId && (this.newPropValue || this.newPropValue === 0)) {
      this.setProperty(this.userId, this.newPropId, this.newPropValue)
        .then(({ value }) => {
          this.setNewProperty(value)

          this.newPropValue = null
          this.newPropId = null
          this.isOpen = false
        })
    } else {
      warningNotificationWrapper(this.$t('warning').toString(), this.$t('set_data_warning_alert').toString())
    }
  }

  @Emit('setNewProperty')
  setNewProperty(value: any): any {
    return { id: this.newPropId, value }
  }
}
